// frontend/src/layouts/AppLayout.tsx

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../components/layout/Navbar';
import { Sidebar } from '../components/layout/Sidebar';
import { AchievementToastHost } from '../components/games/AchievementToastHost';
import '../styles/layout.css';

export function AppLayout() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-layout">
      <Navbar />

      {/* Hamburger: toggle sidebar open/close */}
      <button
        className={`app-mobile-menu-btn${isSidebarOpen ? ' is-open' : ''}`}
        onClick={() => setSidebarOpen(prev => !prev)}
        aria-label={isSidebarOpen ? 'Menüyü kapat' : 'Menüyü aç'}
        aria-expanded={isSidebarOpen}
      >
        {isSidebarOpen ? '✕' : '☰'}
      </button>

      <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />

      <AchievementToastHost />

      <main className="app-main-content">
        <Outlet />
      </main>
    </div>
  );
}
